import FJConfig from '../config/FJConfig';
import FJS3Config from '../config/FJS3Config';
import FJUtil from '../util/FJUtil';
import FJCompressedImageStore from './FJCompressedImageStore';
import FJS3NetworkManager from './FJS3NetworkManager';

let _watermarkCanvas = null;
const watermarkPicUrl = FJConfig.imgPath + 'watermark.png?v=' + FJConfig.version;
let watermarkWidth = 219;
let watermarkHeight = 66;
const FJImageStore = {
    drawWatermarkOnPicture(originImgUrl) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (res, rej) => {
            const _onError = () => {
                rej();
            };
            if (!_watermarkCanvas) {
                const result = await this.initWatermarkCanvas();
                if (!result) {
                    _onError();
                    return;
                }
            }
            const watermarkSpaceRate = FJUtil.isMobile() ? 0.04 : 0.02; // 水印间距 图片宽的百分比
            const watermarkWidthRate = FJUtil.isMobile() ? 1 / 4 : 1 / 5; // 水印宽度，高自适应  图片宽的比例

            const originImg = new Image();
            originImg.setAttribute('crossOrigin', 'Access-Control-Allow-Origin');
            originImg.src = originImgUrl;

            originImg.onload = function () {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const { width, height } = originImg;
                canvas.width = width;
                canvas.height = height;
                const watermarkSpace = width * watermarkSpaceRate;
                const renderWatermarkW = width * watermarkWidthRate;
                const renderWatermarkH = renderWatermarkW * (watermarkHeight / watermarkWidth);
                ctx.drawImage(originImg, 0, 0);
                ctx.drawImage(
                    _watermarkCanvas,
                    width - renderWatermarkW - watermarkSpace,
                    height - renderWatermarkH - watermarkSpace,
                    renderWatermarkW,
                    renderWatermarkH,
                );
                canvas.toBlob(blob => {
                    res(blob);
                });
            };
            originImg.onerror = _onError;
        });
    },

    async initWatermarkCanvas() {
        try {
            if (_watermarkCanvas) {
                return;
            }
            const waterMarkImg = new Image();
            waterMarkImg.setAttribute('crossOrigin', 'Access-Control-Allow-Origin');
            waterMarkImg.src = watermarkPicUrl;

            return await new Promise((resolve, reject) => {
                waterMarkImg.onload = function () {
                    const { width, height } = waterMarkImg;
                    watermarkWidth = width;
                    watermarkHeight = height;
                    _watermarkCanvas = document.createElement('canvas');
                    const _watermarkCtx = _watermarkCanvas.getContext('2d');
                    _watermarkCanvas.width = watermarkWidth;
                    _watermarkCanvas.height = watermarkHeight;
                    _watermarkCtx.drawImage(waterMarkImg, 0, 0);
                    resolve(true);
                };
                waterMarkImg.onerror = () => {
                    reject();
                    _watermarkCanvas = null;
                };
            });
        } catch (e) {
            _watermarkCanvas = null;
            return false;
        }
    },
    upLoadFileToS3Async(file, key) {
        return new Promise(resolve => {
            FJS3NetworkManager.uploadToS3(file, key, response => {
                if (key !== response.key) return;
                switch (response.type) {
                    case 'progress':
                        break;
                    case 'done':
                        resolve(true);
                        break;
                    case 'error':
                        resolve(false);
                        break;
                    default:
                }
            });
        });
    },
    async getImageRatio(imgUrl) {
        const image = new Image();
        image.setAttribute('crossOrigin', 'Access-Control-Allow-Origin');
        image.src = imgUrl;
        return await new Promise((resolve, reject) => {
            image.onload = function () {
                const { width, height } = image;
                return resolve(width / height);
            };
            image.onerror = () => {
                reject();
            };
        });
    },
    async getImageInfo(imgUrl) {
        const image = new Image();
        image.setAttribute('crossOrigin', 'Access-Control-Allow-Origin');
        image.src = imgUrl;
        return await new Promise((resolve, reject) => {
            image.onload = function () {
                const { width, height } = image;
                return resolve({
                    width,
                    height,
                });
            };
            image.onerror = () => {
                reject();
            };
        });
    },
    async upLoadFileToS3ByUrl(url, options = {}) {
        const { isCompress, maxWidth, maxHeight } = options;
        const blob = isCompress
            ? await FJCompressedImageStore.simpleCompressImage(url, maxWidth, maxHeight)
            : await FJUtil.getBlobByUrl(url);
        if (!blob) return;

        return await this.uploadFileByBlob(blob);
    },

    /**
     * 上传使用的原图图片到s3
     * @param {Blob} blob
     * @param {bool} isUploadExport  是否上传到ai生成结果图片位置
     */
    async uploadFileByBlob(blob, isUploadExport = false) {
        // 这个接口在失败时返回 undefined 是因为外部的已有逻辑中没有处理 catch 的情况，大部分是以是否有结果来判断是否成功
        // 所以基于兼容性的考虑，这里需要使用 try catch 来捕获错误并在 catch 中返回 undefined
        try {
            const id = await FJUtil.hashEncode(blob);
            if (!id) return;
            const key = (!isUploadExport ? FJConfig.originalImageKey : FJConfig.resultImageKey) + `${id}.png`;
            return await new Promise((resolve, reject) => {
                FJS3NetworkManager.uploadToS3(blob, key, response => {
                    if (key !== response.key) return;
                    switch (response.type) {
                        case 'progress':
                            break;
                        case 'done':
                            resolve(FJS3Config.S3_SERVER_HOST + key);
                            break;
                        case 'error':
                            reject(new Error(response.msg || 'Upload failed'));
                            break;
                        default:
                    }
                });
            });
        } catch (e) {
            console.log(e);
            return;
        }
    },
    async uploadFilesByUrl(urls, isCompress = false) {
        const files = [];
        for (let i = 0; i < urls.length; i++) {
            const url = urls[i];
            const file = isCompress
                ? await FJCompressedImageStore.simpleCompressImage(url)
                : await FJUtil.getBlobByUrl(url);
            const id = await FJUtil.hashEncode(file);
            const key = FJConfig.originalImageKey + `${id}.png`;
            files.push({ file, key, url, s3Url: FJS3Config.S3_SERVER_HOST + key });
        }
        const data = await FJS3NetworkManager.batchUploadToS3(files);
        return data.map(i => i?.value?.data?.Location || '');
    },
};
export default FJImageStore;
